<template>
    <div class="container-fluid content">
        <div class="mt-2 mx-auto" v-if="!loggedIn">
            <heading title="Anmelden" class="text-center"/>
            <login @login="login($event)"/>
        </div>
        <div v-if="loggedIn" class="container p-4 mx-auto">
            Du bist bereits eingeloggt ...
        </div>
    </div>
</template>

<script>
import Login from '../components/auth/Login'
import {mapActions, mapGetters} from 'vuex'
import Heading from "@/components/global/Heading.vue";

export default {
    computed: {
        ...mapGetters(['loggedIn', 'authtoken'])
    },
    methods: {
        ...mapActions(['loginAction']),
        login(credentials) {
            if (credentials.email && credentials.password)
                this.loginAction({login: credentials.email, password: credentials.password});
        },
    },
    watch: {
        loggedIn: {
            handler: function (newVal) {
                if (newVal) {
                    if (this.$route.query.returnUrl) {
                        let url = this.$route.query.returnUrl
                        window.location.href = url + '?sakaliauth=' + this.authtoken.token
                    } else {
                        if (!this.next)
                            this.next = {
                                name: 'bet'
                            };
                        this.$router.replace(this.next)
                    }
                }
            },
            immediate: true
        }
    }
    ,
    components: {
        Heading,
        Login
    }
}
</script>
